import { LocationHistoryService } from "../../services/LocationHistoryService";
import { GpsLocationHistoryService } from "../../services/GpsLocationHistoryService";
import { LocationHistory } from "../../entities/LocationHistory";
import { AssetService } from "../../services/AssetService";

export class AssetLocationHistoriesModel {
    $q:ng.IQService;
    entityId:number;
    allLocationHistories:LocationHistory[] = [];
    gpsHistoryCount:number = 0;
    static $inject = ['$q','AssetService','LocationHistoryService','GpsLocationHistoryService'];
    constructor($q: ng.IQService,
            public assetService: AssetService,
            public locationHistoryService:LocationHistoryService,
            public gpsLocationHistoryService:GpsLocationHistoryService){
        this.$q = $q;
    }
    init(entityId:number):ng.IPromise<boolean>{
        if (entityId == null) {
            return this.$q.when<boolean>(true);
        }
        this.entityId = entityId;
        return this.$q.all([
            this.locationHistoryService.getByAsset(entityId),
            this.gpsLocationHistoryService.getCountByAsset(entityId)]
        ).then((data)=>{
            this.allLocationHistories = data[0];
            this.gpsHistoryCount = data[1];
            return this.$q.when<boolean>(true);
        });
    }
    hasGpsHistory():boolean {
        return (this.gpsHistoryCount > 0);
    }
}
